import { render, staticRenderFns } from "./TabsCompetenciaComponent.vue?vue&type=template&id=00a07dd4&scoped=true"
import script from "./TabsCompetenciaComponent.vue?vue&type=script&lang=js"
export * from "./TabsCompetenciaComponent.vue?vue&type=script&lang=js"
import style0 from "./TabsCompetenciaComponent.vue?vue&type=style&index=0&id=00a07dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a07dd4",
  null
  
)

export default component.exports